import React from "react";
import BreadCrumb from "../../Components/BreadCrumb";

const CaseSearchPage = (benchId) => {
  return (
    <>
      <div className="col-12 col-sm-12 col-md-9 col-lg-9">
        <BreadCrumb title="Case Search" />
        <div className="about-bg inner-page-section">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <h4>Data Coming Soon..... </h4>
                {/* <DailyOrder benchId={benchId} /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CaseSearchPage;
